module.exports = __webpack_public_path__ + "img/07.d0cc5a01.png";